let CALLBACK_URI = "";
let LOGOUT_REDIRECT_URI = "";
if (window.location.hostname === "a-dev.tbbt.com.tw"){
  CALLBACK_URI = `https://a-dev.tbbt.com.tw/app/reference-frontend-view/auth/logincallback.html`
  LOGOUT_REDIRECT_URI = `https://a-dev.tbbt.com.tw/app/reference-frontend-view/index.html#`

} else if (window.location.hostname === "qa-textbook.hle.com.tw"){
  CALLBACK_URI = `https://qa-textbook.hle.com.tw/auth/logincallback.html`
  LOGOUT_REDIRECT_URI = `https://qa-textbook.hle.com.tw/index.html`

}else if (window.location.hostname === "textbook.hle.com.tw" ) {
  CALLBACK_URI = `https://textbook.hle.com.tw/auth/logincallback.html`
  LOGOUT_REDIRECT_URI = `https://textbook.hle.com.tw/index.html`

} else if (window.location.hostname === "qa-reference.hle.com.tw" ) {
  CALLBACK_URI = `https://qa-reference.hle.com.tw/auth/logincallback.html`
  LOGOUT_REDIRECT_URI = `https://qa-reference.hle.com.tw/index.html`

} else if (window.location.hostname === "reference.hle.com.tw" ) {
  CALLBACK_URI = `https://reference.hle.com.tw/auth/logincallback.html`
  LOGOUT_REDIRECT_URI = `https://reference.hle.com.tw/index.html`

} else {
  CALLBACK_URI = `http://localhost:8081/auth/logincallback.html`
  LOGOUT_REDIRECT_URI = `http://localhost:8081/index.html`;
}

class AuthenticationService {
  userManager = null;

  constructor() {
    // create the login message: 包含登入頁面要導向哪裡, 登入後要跳轉到哪裡等等
    const OIDC_AUTHORITY = "https://id.hle.com.tw";
    const OIDC_REDIRECT_URI = CALLBACK_URI;
    const POST_LOGOUT_REDIRECT_URI = LOGOUT_REDIRECT_URI;

    this.userManager = new Oidc.UserManager({
      userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
      authority: OIDC_AUTHORITY, //Authorization server地址
      client_id: "js",  //Client Id,需要在Authorization Server配置好
      redirect_uri: OIDC_REDIRECT_URI, //redirect url, 用於接受授權碼，然後通過 token 換取 id_token和access_token
      popup_redirect_uri: OIDC_REDIRECT_URI,
      post_logout_redirect_uri: POST_LOGOUT_REDIRECT_URI,
      response_type: "code",  //授權方式，一般SPA應用首選的授權方式
      scope: "openid profile offline_access",  //請求授權的scope，包含需要獲取的用戶訊息以及想訪問的資源權限
      automaticSilentRenew: true,
      popupWindowTarget: "_self"
    });
  }

  // 攜帶著UserManager object，並跳轉到 hanlin login 頁面
  signInRedirect() {
    this.userManager.signinRedirect();
  }

  // 直接跳轉到登出頁面
  signOutRedirect() {
    return this.userManager.signoutRedirect();
  }


  // 取得使用者資訊
  getUser() {
    return this.userManager.getUser();
  }

  // 取得使用者資訊，透過 userinfo endpoint
  getUserByEndpoint(accessToken){
    const url = new URL(window.location.href);
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: 'https://id.hle.com.tw/connect/userinfo',
      headers: { 'Authorization': 'Bearer ' + accessToken}
    }
    return axios.request(config)
  }
}

